import { AssetAvailableSchedule, ScheduleItemMainExtra } from "slot-definitions"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_ADVANCED_REGIME_TABS } from "routes/asset-register/feature-flag-asset-mapping"
import { Bound } from "lib/@components/binding/Bound"
import { Summary } from "routes/schedule/plugins/ai-summary/summary"
import { ManuallySelectedScheduleItem } from "routes/asset-register/plugins/asset-mapping/manual-mapping-slot-definitions"

ScheduleItemMainExtra.plug(<Summary $lazy if={isEnabled(FEATURE_FLAG_ADVANCED_REGIME_TABS)} priority={500} />)
AssetAvailableSchedule.plug(<Summary $lazy if={isEnabled(FEATURE_FLAG_ADVANCED_REGIME_TABS)} priority={190} />)
ManuallySelectedScheduleItem.plug(<Summary $lazy if={isEnabled(FEATURE_FLAG_ADVANCED_REGIME_TABS)} priority={190} />)

export function ScheduleSummary({ id, label, focused, ...props }) {
    return (
        <Bound schedule={{ _id: id, label }}>
            <Summary $lazy focused={focused} {...props} />
        </Bound>
    )
}
